import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import ChatBox from './chatbox'
import ActionsBox from './actions'
import Details from './details'
import List from './list'
import Side from '../../components/Sidebar'
import Homeright from './HomeRight'
import cookie from '../../helper/cookie'
import Relay from 'react-relay';
import AddReviewLinkMutation from '../../mutations/AddReviewLinkMutation'
import AddReportLinkMutation from '../../mutations/AddReportLinkMutation'
import ChangeStepMutation from '../../mutations/ChangeStepMutation'
import ChangeStatusMutation from '../../mutations/ChangeStatusMutation'

class Adminpage extends Component {
constructor(props)
{
  super(props);
  var surveylink="";
  var reportlink="";
  var teamData = [];
  var chatboxData = {};
  var date;
  console.log("shruti",this.props.viewer.myProjects[0]);
  if(this.props.viewer.myProjects[0] != null) {
    date = new Date(this.props.viewer.myProjects[0].startDate);
    date = String(date).split(" ")[2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
    
    
    if (this.props.viewer.myProjects[0].linkToReview == null){
      surveylink = ""
    }
    else {
      surveylink = this.props.viewer.myProjects[0].linkToReview
    }
    
    if (this.props.viewer.myProjects[0].linkToReport == null){
      reportlink = ""
    }
    else {
      reportlink = this.props.viewer.myProjects[0].linkToReport
    }

   
    this.props.viewer.myProjects[0].users.map((object, index) => {
      teamData.push({
        customeremail: object.email,
        customerimg: object.picture
      });
    });

    var hashTags = [];
    this.props.viewer.hashTags.map((object, index) => {
      hashTags.push({
        tag: object.tag,
        message: object.message
      });
    });

    chatboxData = {
      projectMembers: teamData,
      hashTags: hashTags,
      agents: [{
        agentimg: this.props.viewer.picture,
        agentemail: this.props.viewer.name
      }],
      frontfacer: this.props.viewer.myProjects[0].frontfacer,
      agentName: this.props.viewer.name,
      agentId: this.props.viewer.pid,
      pid: this.props.viewer.myProjects[0].pid
    }
  }
  
  var unread = [];
  this.props.viewer.unAsssignedProjects.map((object, index) => {
    
    var date = new Date(object.created);
    var day = String(date).split(" ")[2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
    var time = String(date).split(" ")[4].split(":")[0] + ":" + String(date).split(" ")[4].split(":")[1];

    unread.push({
      ProjectNumber: object.name,
      pid: object.pid,
      Date: day,
      TimeOfMail: time,
      CustomerName: object.customer.name,
      customerId: object.customer.pid 
    })
  });

  var myProjects = [];
  this.props.viewer.myProjects.map((object, index) => {
    
    var date = new Date(object.created);
    var day = String(date).split(" ") [2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
    var time = String(date).split(" ")[4].split(":")[0] + ":" + String(date).split(" ")[4].split(":")[1];

    myProjects.push({
      ProjectNumber: object.name,
      pid: object.pid,
      Date: day,
      TimeOfMail: time,
      AgentName: "You",
      agentId: this.props.pid 
    })
  });

  if(this.props.viewer.myProjects[0] != null) {
    this.state={
      proj:{
        projectName: this.props.viewer.myProjects[0].name,
        pid: this.props.viewer.myProjects[0].pid,
        step:this.props.viewer.myProjects[0].step,
        status:this.props.viewer.myProjects[0].status,
        respondents:this.props.viewer.myProjects[0].numberOfRespondents,
        start:date,
        surveylink : surveylink,
        reportlink : reportlink,
      },
      chatboxData: chatboxData,
      myProjects: myProjects,
      unread: unread
    };
  }
  else {
    this.state={
      proj:{
        projectName: "",
        pid: 0,
        step:"",
        status:"",
        respondents:0,
        start:"",
        surveylink : surveylink,
        reportlink : reportlink,
      },
      chatboxData: chatboxData,
      myProjects: myProjects,
      unread: unread
    };
  }
  
  this.changeslink=this.changeslink.bind(this);
  this.changerlink=this.changerlink.bind(this);
  this.changestep=this.changestep.bind(this);
  this.changestatus=this.changestatus.bind(this);
  this.traverse=this.traverse.bind(this);
  this.createForm=this.createForm.bind(this);
  this.viewForm=this.viewForm.bind(this);
  
}
changeslink(slink)
{ 
  console.log(slink);
  Relay.Store.update(new AddReviewLinkMutation({
      conversationId: this.state.proj.pid,
      linkToReview: slink
    }), {
      onFailure: (t) => {
        console.log('onFailure of AddReviewLinkMutation', t);
      },
      onSuccess: (t) => {
        console.log('onSuccess of AddReviewLinkMutation', t);
      }
  });

  this.setState({
    proj:{
      surveylink:slink,
      reportlink:this.state.proj.reportlink,
      step:this.state.proj.step,
      status:this.state.proj.status,
      respondents:this.state.proj.respondents,
      start:this.state.proj.start,
    }
  });
}

changestep(cstep)
{ 
  console.log(this.state.proj.pid);
  console.log(cstep);
  Relay.Store.update(new ChangeStepMutation({
      conversationId: this.state.proj.pid,
      updatedStep: cstep
    }), {
      onFailure: (t) => {
        console.log('onFailure of ChangeStepMutation', t);
      },
      onSuccess: (t) => {
        console.log('onSuccess of ChangeStepMutation', t);
        this.setState({
          proj:{
            surveylink:this.state.proj.surveylink,
            reportlink:this.state.proj.reportlink,
            step:cstep,
            status:this.state.proj.status,
            respondents:this.state.proj.respondents,
            start:this.state.proj.start,
          }
        });
      }
  });
}

changestatus(stat)
{ 
  console.log(this.state.proj.pid);
  console.log(stat);
  if (stat=="archived"){
    stat = "archive"
  }
  console.log(stat);
  Relay.Store.update(new ChangeStatusMutation({
      conversationId: this.state.proj.pid,
      updatedStatus: stat
    }), {
      onFailure: (t) => {
        console.log('onFailure of ChangeStatusMutation', t);
      },
      onSuccess: (t) => {
        console.log('onSuccess of ChangeStatusMutation', t);
        this.setState({
          proj:{
            surveylink:this.state.proj.surveylink,
            reportlink:this.state.proj.reportlink,
            step:this.state.proj.step,
            status:stat,
            respondents:this.state.proj.respondents,
            start:this.state.proj.start,
          }
        }
        );
      }
  });
}

changerlink(rlink)
{ 
  Relay.Store.update(new AddReportLinkMutation({
      conversationId: this.state.proj.pid,
      linkToReport: rlink
    }), {
      onFailure: (t) => {
        console.log('onFailure of AddReportLinkMutation', t);
      },
      onSuccess: (t) => {
        console.log('onSuccess of AddReportLinkMutation', t);
      }
  });

  this.setState({
    proj:{
      surveylink:this.state.proj.surveylink,
      reportlink:rlink,
      step:this.state.proj.step,
      status:this.state.proj.status,
      respondents:this.state.proj.respondents,
      start:this.state.proj.start,
    }
  });
}
traverse(pid) {
  console.log(pid);
  this.props.viewer.myProjects.map((object, index) => {

    if (object.pid==pid){
      console.log("yup");
      var date = new Date(object.startDate);
      date = String(date).split(" ")[2] + ' ' + String(date).split(" ")[1] + ', ' + String(date).split(" ")[3];
      
      var surveylink;
      if (object.linkToReview == null){
        surveylink = ""
      }
      else {
        surveylink = object.linkToReview
      }
      var reportlink;
      if (object.linkToReport == null){
        reportlink = ""
      }
      else {
        reportlink = object.linkToReport
      }

      var teamData = [];
      object.users.map((object, index) => {
        teamData.push({
          customeremail: object.email,
          customerimg: object.picture
        });
      });

      var hashTags = [];
      this.props.viewer.hashTags.map((object, index) => {
        hashTags.push({
          tag: object.tag,
          message: object.message
        });
      });

      var chatboxData = {
        projectMembers: teamData,
        hashTags: hashTags,
        agents: [{
          agentimg: this.props.viewer.picture,
          agentemail: this.props.viewer.name
        }],
        frontfacer: object.frontfacer,
        agentName: this.props.viewer.name,
        agentId: this.props.viewer.pid,
        pid: object.pid
      }

      this.setState({
        proj:{
          projectName: object.name,
          pid: object.pid,
          step:object.step,
          status:object.status,
          respondents:object.numberOfRespondents,
          start:date,
          surveylink : surveylink,
          reportlink : reportlink,
        },
        chatboxData: chatboxData
      });
    }
    else {
      console.log("nah");
    }
    // myProjects.push({
    //   ProjectNumber: object.name,
    //   pid: object.pid,
    //   Date: day,
    //   TimeOfMail: time,
    //   AgentName: "You",
    //   agentId: this.props.pid 
    // })
  });

}
createForm(){
  console.log("here");
  window.location.href = "/#/createForm/" + this.state.proj.pid
}
viewForm(){
  window.location.href = "/#/form/" + this.state.proj.pid;
}
  render()
  {
    var st={
      bttn_attri:{
        height:"44px",
        backgroundColor:"#1a84eb",
        border:"none"
    }
  }
    if (cookie.get('access_token') != null) {
    if(this.props.viewer.myProjects[0] != null){
    return(
      <div style={{backgroundColor:"#fafafa"}}>
        <div className="row">
          <div className="col-md-3">
            <div className="col-md-3" style={{backgroundColor:"#e5e5e5",height:"100%"}}>
                <Side />
            </div>
            <div className="col-md-9" style={{paddingTop:"30px"}}>
                <List unread={this.state.unread} myProjects={this.state.myProjects} traverse={this.traverse}/>
            </div>
          </div>
          <div className="col-md-4" style={{paddingTop:"30px"}}>
              <div className="row" >
                <ChatBox isAgentSide="true" data={this.state.chatboxData} />
              </div>
              <button type="button" className="btn btn-info btn-lg pull-left" style={st.bttn_attri} onClick={this.createForm}>Create Form</button>
              <button type="button" className="btn btn-info btn-lg pull-right" style={st.bttn_attri} onClick={this.viewForm}>View Form</button>
          </div>
          <div className="col-md-5" style={{paddingTop:"30px"}}>
            <div className="col-md-11">
              <Homeright project={this.state.proj} handleslink={this.changeslink} handlerlink={this.changerlink} handlestep={this.changestep} handlestatus={this.changestatus}/>
            </div>
          </div>

        </div>
      </div>
    );
  }
  else{
    return(
      <div style={{backgroundColor:"#fafafa"}}>
        <div className="row">
          <div className="col-md-3">
            <div className="col-md-3" style={{backgroundColor:"#e5e5e5",height:"100%"}}>
                <Side />
            </div>
            <div className="col-md-9" style={{paddingTop:"30px"}}>
                <List unread={this.state.unread} myProjects={this.state.myProjects} traverse={this.traverse}/>
            </div>
          </div>
          <strong><h2><div className="text-muted text-center">You currently have no Projects</div></h2></strong>
        </div>
      </div>
    );
  }
  }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }

}

export default Relay.createContainer(Adminpage, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Agent{
        pid
        email
        picture
        name
        hashTags{
          tag
          message
        }
        unAsssignedProjects{
          pid
          name
          created
          customer{
            pid
            picture
            name
          }
        }
        myProjects {
          pid
          name
          created
          linkToReview
          linkToReport
          step
          startDate
          status
          customer {
            name
            picture
            pid
          }
          users {
            email
            picture
            name
          }
          numberOfRespondents
          frontfacer
        }
      }
    `
  }
});



/** WEBPACK FOOTER **
 ** ./src/views/Home/index.js
 **/